import { Body } from 'components';
import { styled } from 'libs/ui/styled';

export const ContentStyled = styled(Body)(() => ({
  flex: 1,
  marginTop: 28,
  padding: 24,
}));
